import styled from 'styled-components';

import UnstyledButton from 'components/unstyled-button';

export const IconButton = styled(UnstyledButton)`
  margin-top: 0.3rem;
  padding: 0;
`;
